import { useCallback } from "react";
import { useParams } from "react-router";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import { useUpdateSKUMutation } from "@/data/mutations";
import { useCMSStore } from "@/hooks/use-cms-store";

export const CMSSaveButton = () => {
  const { skuId } = useParams<{ skuId: string }>();
  const updateSKUMutation = useUpdateSKUMutation(skuId!);
  const pageContent = useCMSStore.use.pageContent();
  const hasUnsavedChanges = useCMSStore.use.hasUnsavedChanges();
  const hasValidationErrors = useCMSStore.use.hasValidationErrors();

  const handleSave = useCallback(() => {
    if (!pageContent) return;

    if (hasValidationErrors) {
      toast.error("Cannot save changes", {
        description: "Please fix the highlighted fields before saving.",
      });
      return;
    }

    updateSKUMutation.mutate({ page_content: pageContent });
  }, [pageContent, hasValidationErrors, updateSKUMutation]);

  return (
    <Button disabled={!hasUnsavedChanges} onClick={handleSave}>
      Save
    </Button>
  );
};
